<template>
<div class="flex justify-center items-center h-full">
  <v-select
    append-to-body
    v-model="params.data.is_paid"
    :options="paymentStatus"
    label="paymentName"
    :reduce="(option) => option.id"
    :class="`payment_stat_fin w-full pay_status_${params.data.is_paid}`"
    :clearable="false"
    :searchable="false"
    @input="params.colDef.CellRendererParams.changeStatus(params.data)"
  >
  </v-select>
</div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'StatusCell',
  components: {
    vSelect
  },
  data () {
    return {
      paymentStatus: [
        { id: 0, paymentName: 'Unpaid' },
        { id: 1, paymentName: 'Paid' }
      ]
    }
  }
}
</script>